module.exports = __webpack_public_path__ + "static/media/fpd_cp_man.221be54c.png";